import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

type Args = {
    signal: AbortSignal | undefined;
    orderId: string;
    customerId: string | null;
    token: string | null;
};

export default function getMyOrder({ signal, orderId, customerId, token }: Args) {
    if (!customerId) {
        return Promise.reject(new Error(shopErrors.orderDetails.message));
    }

    const url = getUrl(`/customers/${customerId}/orders/${orderId}`);

    return shop
        .get(url, {
            signal,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .json<ShopTypes.OrderDetailsResponse>();
}
